import { secretManager, urlManager } from '../config';
import { TokenStorageImpl, UserStorageImpl } from '../storage';
import { AxiosClient, AuthAxiosClient, IubendaAxiosClient } from './client';
import TokenRepositoryImpl from './implementations/token';
import UserRepositoryImpl from './implementations/user';
import SongRepositoryImpl from './implementations/song';
import AuthRepositoryImpl from './implementations/auth';
import TagRepositoryImpl from './implementations/tag';
import InternalStripeRepositoryImpl from './implementations/internalStripe';
import ExternalResourcesRepositoryImpl from './implementations/externalResources';
import IubendaRepositoryImpl from './implementations/iubenda';
import AIRepositoryImpl from './implementations/ai';

const externalResourceClient = new AxiosClient();
const publicEndpointClient = new AxiosClient(urlManager.base);
const tokenRepository = new TokenRepositoryImpl(publicEndpointClient);
const tokenStorage = new TokenStorageImpl();
const authRepository = new AuthRepositoryImpl(tokenRepository, tokenStorage);
const protectedEndpointClient = new AuthAxiosClient(
  urlManager.base,
  authRepository
);
const externalResourcesClient = new AxiosClient();
const externalResourcesRepository = new ExternalResourcesRepositoryImpl(
  externalResourcesClient
);
const tagRepository = new TagRepositoryImpl(publicEndpointClient);
const aiRepository = new AIRepositoryImpl(
  protectedEndpointClient,
  externalResourceClient
);
const songRepository = new SongRepositoryImpl(
  protectedEndpointClient,
  publicEndpointClient,
  externalResourcesRepository
);

const userStorage = new UserStorageImpl();
const userRepository = new UserRepositoryImpl(
  protectedEndpointClient,
  authRepository,
  userStorage
);

const internalStripeRepository = new InternalStripeRepositoryImpl(
  protectedEndpointClient,
  publicEndpointClient
);
const iubendaClient = new IubendaAxiosClient(
  urlManager.iubenda,
  secretManager.iubendaApiKey
);
const iubendaRepository = new IubendaRepositoryImpl(iubendaClient);
const repositories = {
  userRepository,
  songRepository,
  tagRepository,
  aiRepository,
  internalStripeRepository,
  iubendaRepository,
};
export default repositories;
export {
  userRepository,
  songRepository,
  tagRepository,
  aiRepository,
  internalStripeRepository,
  iubendaRepository,
  authRepository,
};
